import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";
import {
  ExplorerService,
  ModalConfig,
  TransferState,
} from "@app/modules/shared/services/explorer.service";
import { Subscription } from "rxjs/Subscription";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";
import { SpeCodeListComponent } from "@dashboard/modules/application-params/specode/components/specode-list/specode-list.component";
import { ApiService } from "@app/modules/shared/services/base/api.service";
import { findIndex, isEmpty } from "lodash";
import { ConvertIsoDateService } from "@app/modules/shared/services/convert-iso-date.service";
import { KlSweetAlertService } from "@app/modules/shared/services/message/kl-sweet-alert.service";
import { KlAlertService } from "@app/modules/shared/services/message/alert.service";
import { KlLoadingService } from "@app/modules/shared/services/kl-loading.service";
import { BehaviorSubject, of, forkJoin } from "rxjs";
import { KlDetailFilterComponent } from "@app/modules/shared/components/kl-detail-filter/kl-detail-filter.component";
import { PrimengLocal } from "@app/modules/shared/constants/primeng-local";
import { UtilService } from "@app/modules/shared/services/util.service";
import { CurrentAccountListComponent } from "@dashboard/modules/finance-management/current-account/components/current-account-list/current-account-list.component";
import { FilterItem } from "@app/modules/shared/model/detail-filter.interface";
import { DocumentTypesEnum } from "@app/modules/shared/enum/document-types.enum";
import { catchError, finalize } from "rxjs/operators";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "kl-current-account-detail-filter",
  templateUrl: "./current-account-detail-filter.component.html",
  styleUrls: ["./current-account-detail-filter.component.scss"],
})
export class CurrentAccountDetailFilterComponent implements OnInit, OnDestroy {
  @Input() entity;
  forkJoinStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  @ViewChild(forwardRef(() => KlDetailFilterComponent), {
    static: true,
  })
  klDetailFilterComponent: any;
  locale =
    PrimengLocal[
      sessionStorage.getItem("currentLanguage")
        ? sessionStorage.getItem("currentLanguage").toUpperCase()
        : "TR"
    ];
  tunnel: Subscription;
  dateFormatString: string;
  alertType: string;
  alertMessage: string;
  alertShow = false;
  entryName: string;
  currentFilter: any;
  saveForm = false;
  selectedFilterValues: Array<FilterItem> = [];
  filterList = [];
  currentAccountCodeExpressionValue: any;
  currentAccountDescriptionExpressionValue: any;
  currentAccountSpecodeExpressionValue1: any;
  currentAccountSpecodeExpressionValue2: any;
  currentAccountSpecodeExpressionValue3: any;
  currentAccountSpecodeExpressionValue4: any;

  private _currentAccountStatusValue: any;
  set currentAccountStatusValue(value: any) {
    this._currentAccountStatusValue = value;
    if (value) {
      const payload = {
        label: "current_account_status",
        key: "currentAccountStatusValue",
        value: value,
        accessor: "status",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_status" },
        payload
      );
    } else {
      this._currentAccountStatusValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_status",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountStatusValue() {
    return this._currentAccountStatusValue;
  }

  private _currentAccountTypeValue: any;
  set currentAccountTypeValue(value: any) {
    if (value) {
      if (value.length > 0) {
        this._currentAccountTypeValue = value;
        const payload = {
          label: "current_account_type",
          key: "currentAccountTypeValue",
          value: value,
          accessor: "type",
        };
        this.insertOrUpdate(
          this.selectedFilterValues,
          { label: "current_account_type" },
          payload
        );
      } else {
        const index = findIndex(this.selectedFilterValues, {
          label: "current_account_type",
        });
        if (index >= 0) {
          this.selectedFilterValues.splice(index, 1);
          this._currentAccountTypeValue = null;
        }
      }
    } else {
      this._currentAccountTypeValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_type",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountTypeValue() {
    return this._currentAccountTypeValue;
  }

  private _currentAccountCodeValue: any;
  set currentAccountCodeValue(value: any) {
    if (value) {
      this._currentAccountCodeValue = value;
      const payload = {
        label: "current_account_code",
        key: "currentAccountCodeValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_code" },
        payload
      );
    } else {
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_code",
      });
      this._currentAccountCodeValue = null;
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountCodeValue() {
    return this._currentAccountCodeValue;
  }

  private _currentAccountDescriptionValue: any;
  set currentAccountDescriptionValue(value: any) {
    if (value) {
      this._currentAccountDescriptionValue = value;
      const payload = {
        label: "current_account_description",
        key: "currentAccountDescriptionValue",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_description" },
        payload
      );
    } else {
      this._currentAccountDescriptionValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_description",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountDescriptionValue() {
    return this._currentAccountDescriptionValue;
  }

  private _currentAccountSpeCodeValue1: any;
  set currentAccountSpeCodeValue1(value: any) {
    if (value) {
      this._currentAccountSpeCodeValue1 = value;
      const payload = {
        label: "current_account_special_code",
        key: "currentAccountSpeCodeValue1",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_special_code" },
        payload
      );
    } else {
      this._currentAccountSpeCodeValue1 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_special_code",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountSpeCodeValue1() {
    return this._currentAccountSpeCodeValue1;
  }

  private _currentAccountSpeCodeValue2: any;
  set currentAccountSpeCodeValue2(value: any) {
    if (value) {
      this._currentAccountSpeCodeValue2 = value;
      const payload = {
        label: "current_account_special_code2",
        key: "currentAccountSpeCodeValue2",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_special_code2" },
        payload
      );
    } else {
      this._currentAccountSpeCodeValue2 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_special_code2",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountSpeCodeValue2() {
    return this._currentAccountSpeCodeValue2;
  }

  private _currentAccountSpeCodeValue3: any;
  set currentAccountSpeCodeValue3(value: any) {
    if (value) {
      this._currentAccountSpeCodeValue3 = value;
      const payload = {
        label: "current_account_special_code3",
        key: "currentAccountSpeCodeValue3",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_special_code3" },
        payload
      );
    } else {
      this._currentAccountSpeCodeValue3 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_special_code3",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountSpeCodeValue3() {
    return this._currentAccountSpeCodeValue3;
  }

  private _currentAccountSpeCodeValue4: any;
  set currentAccountSpeCodeValue4(value: any) {
    if (value) {
      this._currentAccountSpeCodeValue4 = value;
      const payload = {
        label: "current_account_special_code4",
        key: "currentAccountSpeCodeValue4",
        value: value,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_special_code4" },
        payload
      );
    } else {
      this._currentAccountSpeCodeValue4 = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_special_code4",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountSpeCodeValue4() {
    return this._currentAccountSpeCodeValue4;
  }

  private _currentAccountUserValue: any;
  set currentAccountUserValue(value: any) {
    if (value) {
      this._currentAccountUserValue = value;
      const payload = {
        label: "current_account_user",
        key: "currentAccountUserValue",
        value: value,
        accessor: "username",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "current_account_user" },
        payload
      );
    } else {
      this._currentAccountUserValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "current_account_user",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountUserValue() {
    return this._currentAccountUserValue;
  }

  private _currentAccountLastChangedUserValue: any;
  set currentAccountLastChangedUserValue(value: any) {
    if (value) {
      this._currentAccountLastChangedUserValue = value;
      const payload = {
        label: "last_changed_user",
        key: "currentAccountLastChangedUserValue",
        value: value,
        accessor: "username",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_changed_user" },
        payload
      );
    } else {
      this._currentAccountLastChangedUserValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_changed_user",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get currentAccountLastChangedUserValue() {
    return this._currentAccountLastChangedUserValue;
  }

  private _firstDate: Date;
  set firstDate(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._firstDate = new Date(
          this.dateConvert.convertDate(value) + " 00:00:00"
        );
      } else if (typeof value === "string") {
        this._firstDate = new Date(value);
      }
      const payload = {
        label: "first_record_date",
        key: "firstDate",
        value: this._firstDate,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "first_record_date" },
        payload
      );
    } else {
      this._firstDate = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "first_record_date",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get firstDate() {
    return this._firstDate;
  }

  private _lastDate: Date;
  set lastDate(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._lastDate = new Date(
          this.dateConvert.convertDate(value) + " 23:59:59"
        );
      } else if (typeof value === "string") {
        this._lastDate = new Date(value);
      }
      const payload = {
        label: "last_record_date",
        key: "lastDate",
        value: this._lastDate,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_record_date" },
        payload
      );
    } else {
      this._lastDate = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_record_date",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get lastDate() {
    return this._lastDate;
  }

  private _changedUserValue: any;
  set changedUserValue(value: any) {
    if (value) {
      this._changedUserValue = value;
      const payload = {
        label: "last_changed_user",
        key: "changedUserValue",
        value: value,
        accessor: "username",
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_changed_user" },
        payload
      );
    } else {
      this._changedUserValue = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_changed_user",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get changedUserValue() {
    return this._changedUserValue;
  }

  private _firstDateLastChanged: Date;
  set firstDateLastChanged(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._firstDateLastChanged = new Date(
          this.dateConvert.convertDate(value) + " 00:00:00"
        );
      } else if (typeof value === "string") {
        this._firstDateLastChanged = new Date(value);
      }
      const payload = {
        label: "first_date_changed",
        key: "firstDateLastChanged",
        value: this._firstDateLastChanged,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "first_date_changed" },
        payload
      );
    } else {
      this._firstDateLastChanged = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "first_date_changed",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get firstDateLastChanged() {
    return this._firstDateLastChanged;
  }

  private _lastDateLastChanged: Date;
  set lastDateLastChanged(value: any) {
    if (value) {
      if (value instanceof Date) {
        this._lastDateLastChanged = new Date(
          this.dateConvert.convertDate(value) + " 23:59:59"
        );
      } else if (typeof value === "string") {
        this._lastDateLastChanged = new Date(value);
      }
      const payload = {
        label: "last_date_changed",
        key: "lastDateLastChanged",
        value: this._lastDateLastChanged,
      };
      this.insertOrUpdate(
        this.selectedFilterValues,
        { label: "last_date_changed" },
        payload
      );
    } else {
      this._lastDateLastChanged = null;
      const index = findIndex(this.selectedFilterValues, {
        label: "last_date_changed",
      });
      if (index >= 0) {
        this.selectedFilterValues.splice(index, 1);
      }
    }
  }

  get lastDateLastChanged() {
    return this._lastDateLastChanged;
  }

  currentAccountUserOptions: any;
  currentAccountSpecodeListComponent = SpeCodeListComponent;
  currentAccountList = CurrentAccountListComponent;
  currentAccountStatusOptions = [
    {
      label: this.translateService.instant("ALL"),
      value: null,
    },
    {
      label: this.translateService.instant("ACTIVE"),
      value: {
        status: "ACTIVE",
      },
    },
    {
      label: this.translateService.instant("PASSIVE"),
      value: {
        status: "PASSIVE",
      },
    },
  ];
  currentAccountTypeOptions = [
    {
      label: this.translateService.instant(DocumentTypesEnum.CUSTOMER_SELLER),
      value: {
        type: DocumentTypesEnum.CUSTOMER_SELLER,
      },
    },
  ];
  currentAccountExpressionOptions = [
    {
      label: this.translateService.instant("LIKE"),
      value: "LIKE",
    },
    {
      label: this.translateService.instant("NOT_LIKE"),
      value: "NOT_LIKE",
    },
    {
      label: this.translateService.instant("EQ"),
      value: "EQ",
    },
    {
      label: this.translateService.instant("NOT_EQ"),
      value: "NOT_EQ",
    },
    // {
    //   label: this.translateService.instant('IN'),
    //   value: 'IN'
    // },
    // {
    //   label: this.translateService.instant('NOT_IN'),
    //   value: 'NOT_IN'
    // },
    {
      label: this.translateService.instant("START_WITH"),
      value: "START_WITH",
    },
    {
      label: this.translateService.instant("END_WITH"),
      value: "END_WITH",
    },
    {
      label: this.translateService.instant("GT"),
      value: "GT",
    },
    {
      label: this.translateService.instant("GE"),
      value: "GE",
    },
    {
      label: this.translateService.instant("LT"),
      value: "LT",
    },
    {
      label: this.translateService.instant("LE"),
      value: "LE",
    },
  ];

  constructor(
    private explorerService: ExplorerService,
    private alertService: KlSweetAlertService,
    private klLoadingService: KlLoadingService,
    private utilService: UtilService,
    private klAlertService: KlAlertService,
    private dateConvert: ConvertIsoDateService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private apiService: ApiService
  ) {
    this.dateFormatString = UtilService.dateFormatString
      .toLowerCase()
      .replace("yy", "");
    this.tunnel = this.explorerService.transferState$.subscribe((state) => {
      switch (state.state) {
        case "CURRENT_ACCOUNT_DETAIL_FILTER_SPECODE1_CURRENT_ITEM":
          this.currentAccountSpeCodeValue1 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_DETAIL_FILTER_SPECODE2_CURRENT_ITEM":
          this.currentAccountSpeCodeValue2 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_DETAIL_FILTER_SPECODE3_CURRENT_ITEM":
          this.currentAccountSpeCodeValue3 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_DETAIL_FILTER_SPECODE4_CURRENT_ITEM":
          this.currentAccountSpeCodeValue4 = state.payload.code;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_DETAIL_FILTER_CURRENT_ACCOUNT_CODE_CURRENT_ITEM":
          this.currentAccountCodeValue = state.payload.code;
          this.cd.markForCheck();
          break;
        case "CURRENT_ACCOUNT_DETAIL_FILTER_CURRENT_ACCOUNT_DESCRIPTION_CURRENT_ITEM":
          this.currentAccountDescriptionValue = state.payload.description;
          this.cd.markForCheck();
          break;
      }
    });
  }

  ngOnInit() {
    this.currentAccountCodeExpressionValue = "LIKE";
    this.currentAccountDescriptionExpressionValue = "LIKE";
    this.currentAccountSpecodeExpressionValue1 = "LIKE";
    this.currentAccountSpecodeExpressionValue2 = "LIKE";
    this.currentAccountSpecodeExpressionValue3 = "LIKE";
    this.currentAccountSpecodeExpressionValue4 = "LIKE";
    this.klLoadingService.show("loading");
    let commitObject = Object.create(null);
    commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      module: this.entity.module,
      key: this.entity.state,
    };
    const preference = this.apiService
      .getFilteredData("design", commitObject)
      .pipe(catchError((error: any) => this.handleError(error)));
    const users = this.apiService
      .getAllData("user")
      .pipe(catchError((error: any) => this.handleError(error)));
    forkJoin([preference, users])
      .pipe(
        finalize(() => {
          this.klLoadingService.hide();
          if (this.entity.filter) {
            this.selectFilter({
              item: { content: JSON.stringify(this.entity.filter) },
              select: false,
            });
          }
          this.cd.markForCheck();
        })
      )
      .subscribe(
        ([preferenceResponse, userResponse]) => {
          this.currentAccountUserOptions = userResponse;
          this.filterList = preferenceResponse.data;
          if (!this.entity.filter) {
            this.filterList.forEach((filter) => {
              if (filter.level_default === "DEFAULT") {
                this.selectFilter({ item: filter, select: true });
              }
            });
          }
          this.forkJoinStatus.next(true);
        },
        (error) => this.alertService.alertError({}, error)
      );
  }

  getFilters() {
    const commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      module: this.entity.module,
      key: this.entity.state,
    };
    this.apiService.getFilteredData("design", commitObject).subscribe(
      (resPreference) => {
        this.filterList = resPreference.data;
        this.cd.markForCheck();
      },
      (errPreference) => {}
    );
  }

  selectFilter(event) {
    this.clearAll();
    if (event.select) {
      this.currentFilter = event.item;
    }
    let selectObject: any;
    selectObject = JSON.parse(event.item.content);
    const filterObject = selectObject["filter"];
    const paramsObject = selectObject["parameters"];
    this.selectedFilterValues = [];
    const parametersObject = [];
    if (filterObject.hasOwnProperty("status")) {
      this.currentAccountStatusValue = { status: filterObject["status"] };
    }
    if (filterObject.hasOwnProperty("types")) {
      if (filterObject["types"].length > 1) {
        const types = [];
        for (let i = 0; i < filterObject["types"].length; i++) {
          types.push({ type: filterObject["types"][i] });
        }
        this.currentAccountTypeValue = types;
      } else if (filterObject["types"].length === 1) {
        this.currentAccountTypeValue = [{ type: filterObject["types"][0] }];
      }
    }
    if (filterObject.hasOwnProperty("code")) {
      this.currentAccountCodeValue = filterObject["code"];
      paramsObject.forEach((params) => {
        if (params.name === "code") {
          this.currentAccountCodeExpressionValue =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "code",
        expression: { operator: this.currentAccountCodeExpressionValue },
      });
    }
    if (filterObject.hasOwnProperty("description")) {
      this.currentAccountDescriptionValue = filterObject["description"];
      paramsObject.forEach((params) => {
        if (params.name === "description") {
          this.currentAccountDescriptionExpressionValue =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "description",
        expression: { operator: this.currentAccountDescriptionExpressionValue },
      });
    }
    if (filterObject.hasOwnProperty("special_code")) {
      this.currentAccountSpeCodeValue1 = filterObject["special_code"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code") {
          this.currentAccountSpecodeExpressionValue1 =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code",
        expression: { operator: this.currentAccountSpecodeExpressionValue1 },
      });
    }
    if (filterObject.hasOwnProperty("special_code2")) {
      this.currentAccountSpeCodeValue2 = filterObject["special_code2"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code2") {
          this.currentAccountSpecodeExpressionValue2 =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code2",
        expression: { operator: this.currentAccountSpecodeExpressionValue2 },
      });
    }
    if (filterObject.hasOwnProperty("special_code3")) {
      this.currentAccountSpeCodeValue3 = filterObject["special_code3"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code3") {
          this.currentAccountSpecodeExpressionValue3 =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code3",
        expression: { operator: this.currentAccountSpecodeExpressionValue3 },
      });
    }
    if (filterObject.hasOwnProperty("special_code4")) {
      this.currentAccountSpeCodeValue4 = filterObject["special_code4"];
      paramsObject.forEach((params) => {
        if (params.name === "special_code4") {
          this.currentAccountSpecodeExpressionValue4 =
            params.expression["operator"];
        }
      });
      parametersObject.push({
        name: "special_code4",
        expression: { operator: this.currentAccountSpecodeExpressionValue4 },
      });
    }
    if (filterObject.hasOwnProperty("modified_user")) {
      this.currentAccountLastChangedUserValue =
        this.currentAccountUserOptions.find(
          (user) => user.username === filterObject["modified_user"].username
        );
    }
    if (filterObject.hasOwnProperty("created_user")) {
      this.currentAccountUserValue = this.currentAccountUserOptions.find(
        (user) => user.username === filterObject["created_user"].username
      );
    }
    if (filterObject.hasOwnProperty("created_dates")) {
      if (filterObject["created_dates"]["min"]) {
        this.firstDate = this.dateConvert.utcDate(
          new Date(filterObject["created_dates"]["min"])
        );
      }
      if (filterObject["created_dates"]["max"]) {
        this.lastDate = this.dateConvert.utcDate(
          new Date(filterObject["created_dates"]["max"])
        );
      }
    }
    if (filterObject.hasOwnProperty("modified_dates")) {
      if (filterObject["modified_dates"]["min"]) {
        this.firstDateLastChanged = this.dateConvert.utcDate(
          new Date(filterObject["modified_dates"]["min"])
        );
      }
      if (filterObject["modified_dates"]["max"]) {
        this.lastDateLastChanged = this.dateConvert.utcDate(
          new Date(filterObject["modified_dates"]["max"])
        );
      }
    }
  }

  setModal(title: string, stateSelector: string, template: any, modalId) {
    const modalConfig = <ModalConfig>{
      title: title,
      stateSelector: "CURRENT_ACCOUNT_DETAIL_FILTER_" + stateSelector,
      childTemplate: <DynamicComponent>{
        mode: "DIALOG",
        modalId: modalId,
        dblSelect: true,
        template: template,
      },
    };
    this.explorerService.openModal(modalConfig);
  }

  deleteFromValues(event) {
    this.selectedFilterValues.splice(event.index, 1);
    this[event.item.key] = null;
  }

  deleteSavedFilter(event) {
    this.alertService.alertDelete(
      {
        title: "Uyarı",
        text: "Kayıt Silinecektir",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", event.item.id).subscribe(
          (resDeletePreference) => {
            this.clearAll();
            this.filterList.splice(event.index, 1);
            this.cd.markForCheck();
          },
          (errDeletePreference) => {
            this.alertService.alertError({}, errDeletePreference);
          }
        );
      }
    );
  }

  clearAll() {
    delete this.currentFilter;
    for (let i = 0; i < this.selectedFilterValues.length; i++) {
      this[this.selectedFilterValues[i].key] = null;
      i = i - 1;
    }
    this.selectedFilterValues = [];
  }

  insertOrUpdate(array: any[], meta: any, value: any) {
    const index = findIndex(array, meta);
    if (index >= 0) {
      array.splice(index, 1);
      array.push(value);
      return;
    }
    return array.push(value);
  }

  commitSave(event: any) {
    this.saveForm = true;
    let commitObject = Object.create(null);
    commitObject = {
      parent: {
        module: this.entity.parentModule,
      },
      level: event.levelStatus ? "APPLICATION" : "USER",
      level_default: event.levelDesign ? "DEFAULT" : "NO_DEFAULT",
      description: event.entryName,
      module: this.entity.module,
      type: "FILTER",
      key: this.entity.state,
      content: JSON.stringify(this.prepareFilterObject()),
    };
    switch (event.commitType) {
      case "add":
        this.apiService.addData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            this.getFilters();
            this.selectFilter({ item: resPreference, select: true });
            this.klDetailFilterComponent.closeEntryModal();
          },
          (errPreference) => {
            this.saveForm = false;
            this.alertService.alertError({ title: "error" }, errPreference);
          }
        );
        break;
      case "edit":
        commitObject["id"] = this.currentFilter.id;
        this.apiService.updateData("design", commitObject).subscribe(
          (resPreference) => {
            this.saveForm = false;
            this.getFilters();
            this.selectFilter({ item: resPreference, select: true });
            this.klDetailFilterComponent.closeEntryModal();
          },
          (errPreference) => {
            this.saveForm = false;
            this.alertService.alertError({ title: "error" }, errPreference);
          }
        );
        break;
    }
  }

  commitFilter() {
    if (
      this.firstDate > this.lastDate ||
      this.firstDateLastChanged > this.lastDateLastChanged
    ) {
      this.alertMessage = this.translateService.instant(
        "end_date_cannot_be_less_than_start_date"
      );
      this.alertShow = true;
    } else {
      const preparedFilter: any = this.prepareFilterObject();
      if (preparedFilter.hasOwnProperty("close")) {
        delete preparedFilter.close;
      }
      if (isEmpty(preparedFilter["filter"]["modified_dates"])) {
        delete preparedFilter["filter"]["modified_dates"];
      }
      if (isEmpty(preparedFilter["filter"]["created_dates"])) {
        delete preparedFilter["filter"]["created_dates"];
      }
      const state = <TransferState>{
        state: this.entity.state,
        payload: preparedFilter,
      };
      this.explorerService.transferState(state);
      this.explorerService.closeModal(this);
    }
  }

  closeFilter() {
    const preparedFilter = this.prepareFilterObject();
    Object.assign(preparedFilter, { close: true });
    this.explorerService.transferState({
      state: this.entity.state + "_DETAIL_FILTER",
      payload: preparedFilter,
    });
    this.explorerService.closeModal(this);
  }

  prepareFilterObject() {
    const filterObject = Object.create(null);
    filterObject["modified_dates"] = Object.create(null);
    filterObject["created_dates"] = Object.create(null);
    const parametersObject = [];
    if (this.currentAccountStatusValue) {
      filterObject["status"] = this.currentAccountStatusValue.status;
    }
    if (this.currentAccountTypeValue) {
      filterObject["types"] = this.currentAccountTypeValue.map((o) => {
        return o.type;
      });
    }
    if (this.currentAccountCodeValue) {
      if (this.currentAccountCodeExpressionValue === "IN") {
        if (this.currentAccountCodeValue.includes(";")) {
          this.currentAccountCodeValue = this.currentAccountCodeValue.replace(
            " ",
            ""
          );
          const spliceCodeValue = this.currentAccountCodeValue.split(";");
          filterObject["code"] = spliceCodeValue;
        } else {
          filterObject["code"] = [this.currentAccountCodeValue];
        }
      } else {
        filterObject["code"] = this.currentAccountCodeValue;
      }
      parametersObject.push({
        name: "code",
        expression: { operator: this.currentAccountCodeExpressionValue },
      });
    }
    if (this.currentAccountDescriptionValue) {
      filterObject["description"] = this.currentAccountDescriptionValue;
      parametersObject.push({
        name: "description",
        expression: { operator: this.currentAccountDescriptionExpressionValue },
      });
    }
    if (this.currentAccountSpeCodeValue1) {
      filterObject["special_code"] = this.currentAccountSpeCodeValue1;
      parametersObject.push({
        name: "special_code",
        expression: { operator: this.currentAccountSpecodeExpressionValue1 },
      });
    }
    if (this.currentAccountSpeCodeValue2) {
      filterObject["special_code2"] = this.currentAccountSpeCodeValue2;
      parametersObject.push({
        name: "special_code2",
        expression: { operator: this.currentAccountSpecodeExpressionValue2 },
      });
    }
    if (this.currentAccountSpeCodeValue3) {
      filterObject["special_code3"] = this.currentAccountSpeCodeValue3;
      parametersObject.push({
        name: "special_code3",
        expression: { operator: this.currentAccountSpecodeExpressionValue3 },
      });
    }
    if (this.currentAccountSpeCodeValue4) {
      filterObject["special_code4"] = this.currentAccountSpeCodeValue4;
      parametersObject.push({
        name: "special_code4",
        expression: { operator: this.currentAccountSpecodeExpressionValue4 },
      });
    }
    if (this.currentAccountUserValue) {
      filterObject["created_user"] = {
        username: this.currentAccountUserValue.username,
      };
    }
    if (this.currentAccountLastChangedUserValue) {
      filterObject["modified_user"] = {
        username: this.currentAccountLastChangedUserValue.username,
      };
    }
    if (this.firstDate) {
      const date = this.dateConvert.convertDate(this.firstDate);
      const newDate = new Date(date + "T00:00:01.000Z");
      filterObject["created_dates"]["min"] = newDate.getTime();
      parametersObject.push({
        name: "created_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.lastDate) {
      const date = this.dateConvert.convertDate(this.lastDate);
      const newDate = new Date(date + "T23:59:59.000Z");
      filterObject["created_dates"]["max"] = newDate.getTime();
      parametersObject.push({
        name: "created_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.firstDateLastChanged) {
      const date = this.dateConvert.convertDate(this.firstDateLastChanged);
      const newDate = new Date(date + "T00:00:01.000Z");
      filterObject["modified_dates"]["min"] = newDate.getTime();
      parametersObject.push({
        name: "modified_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    if (this.lastDateLastChanged) {
      const date = this.dateConvert.convertDate(this.lastDateLastChanged);
      const newDate = new Date(date + "T23:59:59.000Z");
      filterObject["modified_dates"]["max"] = newDate.getTime();
      parametersObject.push({
        name: "modified_dates",
        expression: { operator: "BETWEEN" },
      });
    }
    const query = {
      paging: {
        limit: this.entity.pageSize || 10,
        offset: 0,
        fetch: "EAGER",
      },
    };
    return Object.assign(
      {},
      { filter: filterObject },
      { parameters: parametersObject },
      { query: query }
    );
  }

  handleError(error: any) {
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
    return of(null);
  }

  ngOnDestroy() {
    this.tunnel.unsubscribe();
  }
}
